var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 52,
    viewBox: "0 0 36 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8015 14.2461H0V22.467H34.8015V14.2461Z",
    fill: "#9C86B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.4701V14.2492C3.17783 14.255 6.26611 13.1964 8.77201 11.2421C11.2779 9.28784 13.0571 6.55062 13.8256 3.46712C14.1079 2.33306 14.2502 1.16866 14.2492 0H22.4731C22.4737 1.84005 22.2493 3.67327 21.805 5.45886C20.5938 10.3231 17.7883 14.6414 13.8361 17.7247C9.88383 20.8081 5.01269 22.4788 0 22.4701Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7522 51.8096H12.5312V36.3881C12.5381 30.4307 14.9076 24.7193 19.1201 20.5068C23.3326 16.2942 29.044 13.9247 35.0014 13.918V22.1389C31.2236 22.1434 27.6017 23.646 24.9305 26.3173C22.2592 28.9885 20.7566 32.6103 20.7522 36.3881V51.8096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.6244bdd5.svg";
export { ForwardRef as ReactComponent };